module.exports = __webpack_public_path__ + "media/ooo_m.30305a22.mp3";